import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'




function checkSeatsAndSteeringWheelBadges_a8() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}

function addListeners_a8(frontCheckboxesMap, modalsCheckboxesMap) {

	frontCheckboxesMap['N1V'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('N1V',this.checked)
		if (this.checked) {
			frontCheckboxesMap['YXK'].disabled = true
		} else {
			frontCheckboxesMap['YXK'].disabled = false
			checkLocks_a8(frontCheckboxesMap)
		}
		getPackageImages_a8('N1V', frontCheckboxesMap)
	})


	frontCheckboxesMap['YZ1_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ1_A8', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YZ4_A8'].checked == false) { 
				frontCheckboxesMap['YZ4_A8'].disabled = true
			}
			const boxesToUncheck = ['N1V']
			//const boxesToUncheck = ['YXK', 'N1V']
			boxesToUncheck.forEach(key => {
				frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
				frontCheckboxesMap[key].checked = false
				saveStateWithAjax(key, false)
				getPackageImages_a8(key, frontCheckboxesMap)
			});
			frontCheckboxesMap['YXK'].disabled = false;

			/* Clean popup checkboxes */
			jQuery("#ykk_popup_yes").removeClass("is-checked");
			jQuery("#ykk_popup_no").removeClass("is-checked");
			jQuery("#ykk_popup_yes .aui-checkbox__input").prop("disabled", false);
			jQuery("#ykk_popup_no .aui-checkbox__input").prop("disabled", false);
			jQuery("#submit_button").prop("disabled", true);
			
			$("#nv1_modal_message").hide();	
			/* Clean popup checkboxes */
	
		} else {
			frontCheckboxesMap['YXK'].disabled = false			
			frontCheckboxesMap['N1V'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['N1V'].checked = false
			
			checkLocks_a8(frontCheckboxesMap)
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 24) || (CarmodelPopUp == 25) || (CarmodelPopUp == 27))  {
			const modal = document.querySelectorAll('.modal')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a8('YZ1_A8', frontCheckboxesMap)
	})



	frontCheckboxesMap['YZ4_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ4_A8', this.checked);

		let check_language = document.querySelector('html.aui-js');
		let language_value = check_language.getAttribute("lang");

		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YZ1_A8'].checked == false) { 
				frontCheckboxesMap['YZ1_A8'].disabled = true
			}
			//const boxesToUncheck = ['YXK', 'N1V']
			const boxesToUncheck = ['N1V']
			boxesToUncheck.forEach(key => {
				frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
				frontCheckboxesMap[key].checked = false
				saveStateWithAjax(key, false)
				getPackageImages_a8(key, frontCheckboxesMap)
			});
			if (language_value == 'cn'){
				frontCheckboxesMap['YXK'].disabled = false;
			}			

			/* Clean popup checkboxes */
			jQuery("#ykk_popup_yes").removeClass("is-checked");
			jQuery("#ykk_popup_no").removeClass("is-checked");
			jQuery("#ykk_popup_yes .aui-checkbox__input").prop("disabled", false);
			jQuery("#ykk_popup_no .aui-checkbox__input").prop("disabled", false);
			jQuery("#submit_button").prop("disabled", true);

			$("#nv1_modal_message").hide();	
			/* Clean popup checkboxes */
	
		} else {
			if (language_value == 'cn'){
				frontCheckboxesMap['YXK'].disabled = false;
			}				
			frontCheckboxesMap['N1V'].parentElement.classList.remove('is-checked')
			frontCheckboxesMap['N1V'].checked = false
			
			checkLocks_a8(frontCheckboxesMap)
		}
		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if ((CarmodelPopUp == 24) || (CarmodelPopUp == 25) || (CarmodelPopUp == 27))  {
			const modal = document.querySelectorAll('.modal')[0]
			if (this.checked) {
				modal.classList.remove("hidden")		
			} else {
				modal.classList.add("hidden")
			}
		}
		getPackageImages_a8('YZ4_A8', frontCheckboxesMap)

		// Change YTA when YZ4 selected - only for A8 and A8 L
		var CarmodelWheel = document.querySelector("input[name='carmodel']").value
		if ((CarmodelWheel == 22) || (CarmodelWheel == 24)) {
			const ytaImg = document.getElementById("YTA_A8-img");
			if (ytaImg) {
				if ((frontCheckboxesMap['YTA_A8'].checked == true) && (frontCheckboxesMap['YZ4_A8'].checked == true)) {
					ytaImg.src="img/06_paketauswahl/a8/paketauswahl/au65x_paketauswahl_yta_dekoreinlagen_holz_sportoptik.png";
				} else if (frontCheckboxesMap['YZ4_A8'].checked == false) {
					ytaImg.src="img/06_paketauswahl/a8/paketauswahl/au65x_paketauswahl_yta_dekoreinlagen_holz.png";
				}
			}
		}
		// Change YTA when YZ4 selected - only for A8 and A8 L
		
	})
	
	frontCheckboxesMap['YVU_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU_A8',this.checked)
		checkLocks_a8(frontCheckboxesMap)
		getPackageImages_a8('YVU_A8', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YXK'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		if (frontCheckboxesMap['N1V'].checked == true) {
			this.disabled = true
		}
		saveStateWithAjax('YXK',this.checked)
		checkLocks_a8(frontCheckboxesMap)
		getPackageImages_a8('YXK', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YTA_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTA_A8',this.checked)
		checkLocks_a8(frontCheckboxesMap)
		getPackageImages_a8('YTA_A8', frontCheckboxesMap)
		
		// Change YTA when YZ4 selected - only for A8 and A8 L	
		var CarmodelWheel = document.querySelector("input[name='carmodel']").value
		if ((CarmodelWheel == 22) || (CarmodelWheel == 24)) {
			if ((frontCheckboxesMap['YTA_A8'].checked == true) && (frontCheckboxesMap['YZ4_A8'].checked == true)) {				
				document.getElementById("YTA_A8-img").src="img/06_paketauswahl/a8/paketauswahl/au65x_paketauswahl_yta_dekoreinlagen_holz_sportoptik.png";
			}
		}
		// Change YTA when YZ4 selected - only for A8 and A8 L	
	})
	
	frontCheckboxesMap['YTO_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTO_A8',this.checked)
		checkLocks_a8(frontCheckboxesMap)
		getPackageImages_a8('YTO_A8', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YSR_A8'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR_A8',this.checked)
		checkLocks_a8(frontCheckboxesMap)
		getPackageImages_a8('YSR_A8', frontCheckboxesMap)
	})
}

/**Controls frontcheckboxes disable */
function checkLocks_a8(frontCheckboxesMap) {
	
	//DEFINE UNLOCK CONDITIONS	
	const unlockConditionForYZ1_A8 = !frontCheckboxesMap['YZ4_A8'].checked
	const unlockConditionForYZ4_A8 = !frontCheckboxesMap['YZ1_A8'].checked
	const unlockConditionForYVU_A8 = true
	const unlockConditionForYTA_A8 = true
	const unlockConditionForYTO_A8 = true
	const unlockConditionForYSR_A8 = true
	
	//UPDATE VARS 
	frontCheckboxesMap['YZ1_A8'].disabled = !unlockConditionForYZ1_A8
	frontCheckboxesMap['YZ4_A8'].disabled = !unlockConditionForYZ4_A8
	frontCheckboxesMap['YVU_A8'].disabled = !unlockConditionForYVU_A8
	frontCheckboxesMap['YTA_A8'].disabled = !unlockConditionForYTA_A8
	frontCheckboxesMap['YTO_A8'].disabled = !unlockConditionForYTO_A8
	frontCheckboxesMap['YSR_A8'].disabled = !unlockConditionForYSR_A8
	
}


/**Gets images for all packages depending on selected packages */

function getImages_a8(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		getPackageImages_a8(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_a8(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
}


export { addListeners_a8, saveStateWithAjax, checkLocks_a8, getImages_a8, getPackageImages_a8, checkSeatsAndSteeringWheelBadges_a8}

